import { RequestService } from '../../../common/services/RequestService';
import { GET_PAYMENT_METHODS } from '../constants';

export const getPaymentMethodsRequest = payload => {
  return RequestService.get(GET_PAYMENT_METHODS);
};
